import axios from 'axios'
import type { AxiosInstance, AxiosRequestConfig } from 'axios'
import { showFailToast } from 'vant'
import router from '@/router'

// 创建axios实例
const service: AxiosInstance = axios.create({
  baseURL: '/api',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  (response: any) => {
    const res = response.data

    // 业务错误
    if (res.code !== 200) {
      showFailToast(res.message || '请求失败')

      // 401 未授权 - 清除token并跳转登录页
      if (res.code === 401) {
        localStorage.removeItem('token')
        router.push('/login')
      }

      return Promise.reject(new Error(res.message || '请求失败'))
    }

    // 只返回 data 部分，让调用者直接获取数据
    return res.data
  },
  (error) => {
    let message = '网络错误，请稍后重试'

    if (error.response) {
      switch (error.response.status) {
        case 400:
          message = error.response.data?.message || '请求参数错误'
          break
        case 401:
          message = error.response.data?.message || '未授权，请重新登录'
          // 清除token并跳转登录页
          localStorage.removeItem('token')
          router.push('/login')
          break
        case 403:
          message = error.response.data?.message || '拒绝访问'
          break
        case 404:
          message = error.response.data?.message || '请求资源不存在'
          break
        case 429:
          message = error.response.data?.message || '请求太频繁，请稍后再试'
          break
        case 500:
          message = error.response.data?.message || '服务器内部错误'
          break
        default:
          message = error.response.data?.message || '请求失败'
      }
    }

    showFailToast(message)
    return Promise.reject(error)
  }
)

// 封装请求方法
export interface ApiResponse<T = any> {
  code: number
  message: string
  data: T
  timestamp: number
}

export function get<T = any>(url: string, params?: any, config?: AxiosRequestConfig): Promise<T> {
  return service.get(url, { params, ...config })
}

export function post<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
  return service.post(url, data, config)
}

export function put<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
  return service.put(url, data, config)
}

export function del<T = any>(url: string, config?: AxiosRequestConfig): Promise<T> {
  return service.delete(url, config)
}

export default service
